export function DataField({ label, value }) {
    return (
        <div className="bg-white p-2 rounded-md">
            <p className="text-sm">{label}</p>
            <p className="font-medium capitalize">{value}</p>
        </div>
    )
}